import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { PopUpConfirmationType } from "../../../../common/enum/PopUpConfirmationType";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import {
    resetManagementParkingValidationRuleForm,
    setManagementParkingValidationRuleFormPopUp,
} from "../../../../redux/reducers/management/parkingValidation/form";
import { PopUpConfirmation } from "../../../common/popup/popUpConfirmation/popUpConfirmation";
import { PopUpForm } from "../../../common/popup/popUpForm/popUpForm";

import { PopUpCodes } from "../../../../common/enum/PopUpCodes";
import {
    deleteParkingValidationRuleAction,
    postAndPutManagementParkingValidationRuleAction,
} from "../../../../redux/actions/management/parkingValidation/parkingValidation";
import { ManagementParkingValidationForm } from "./form/form";
import { ExceptionType } from "../../../../common/enum/management/ExceptionType";
import { RequiredFieldsMessage } from "../../../common/requiredMessage/requiredMessage";

export const ManagementParkingValidationRuleFormController = () => {
    const { t } = useTranslation("common", { keyPrefix: "MANAGEMENT.PARKING_VALIDATION_RULE" });
    const dispatch = useAppDispatch();
    const { showPopUp, loading, form } = useAppSelector((state) => state.managementParkingValidationRuleForm);

    const onDimissed = () => {
        dispatch(resetManagementParkingValidationRuleForm());
    };
    const onCancel = () => {
        dispatch(setManagementParkingValidationRuleFormPopUp(PopUpCodes.NONE));
        onDimissed();
    };

    const onSave = () => {
        if (showPopUp === PopUpCodes.CREATE || showPopUp === PopUpCodes.UPDATE) {
            dispatch(postAndPutManagementParkingValidationRuleAction()).then((response: any) => {
                response && onCancel();
            });
        } else if (showPopUp === PopUpCodes.DELETE) {
            dispatch(deleteParkingValidationRuleAction()).then((response: any) => {
                response && onCancel();
            });
        }
    };
    const titlePopUp = useMemo(() => {
        switch (showPopUp) {
            case PopUpCodes.CREATE:
                return t("CREATE");
            case PopUpCodes.UPDATE:
                return t("UPDATE");
            default:
                return "";
        }
    }, [showPopUp]);

    const disabledForm = useMemo(() => {
        const isNotValidException = form.validationParkingRuleExceptions.some(
            (exception) =>
                (exception.validationParkingExceptionId === ExceptionType.APPOINTMENT &&
                    exception.deleted !== true &&
                    exception.validationParkingAppointmentExceptionTypeId === null) ||
                (exception.deleted !== true &&
                    exception.validationParkingAppointmentExceptionTypeId !== null &&
                    exception.validationParkingAppointmentExceptionHour === null),
        );
        return !form.description || isNotValidException;
    }, [form]);

    return (
        <>
            <PopUpForm
                content={<ManagementParkingValidationForm />}
                title={titlePopUp}
                isLoading={loading}
                isVisible={showPopUp === PopUpCodes.CREATE || showPopUp === PopUpCodes.UPDATE}
                onCancel={onCancel}
                onSave={onSave}
                onDimissed={onDimissed}
                height={"calc(90vh - 7rem)"}
                width={"80vw"}
                isDisabledButton={disabledForm}
                leftButtonContent={<RequiredFieldsMessage />}
            />

            <PopUpConfirmation
                showPopUp={showPopUp === PopUpCodes.DELETE}
                onCancel={onCancel}
                onDimissed={onDimissed}
                onAccept={onSave}
                type={PopUpConfirmationType.DELETE}
                height={"auto"}
                width={"auto"}
            />
        </>
    );
};
